module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Детали скидки\n    "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'discount-edit',
        params: {
          id: _vm.discount.id
        }
      }
    }
  }, [_vm._v("Редактировать информацию")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'discounts'
      }
    }
  }, [_vm._v("← Назад к Скидкам")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Название")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.discount.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Сумма")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.toMoney(_vm.discount.amount)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Дата начала")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.discount.start_date)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Дата окончания")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.discount.end_date)))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c697885","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount/DiscountDetails.vue
// module id = 613
// module chunks = 0